import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Table, Form, Button, Row, Col, InputGroup, Navbar, NavDropdown, Nav, Offcanvas, Badge } from 'react-bootstrap';
import { Lista_Meus_Alunos } from "../../services/api";

const Meus_Alunos = (props) => {
    const perfil = JSON.parse(localStorage.getItem("perfil"));
    const meu_perfil = perfil[0].perfil;

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];
    const unidades_sigla = ['', 'BR', 'MD', 'SC', 'CD', 'TQ', 'NP', 'NI', '', 'SP', 'BT', 'CG', 'CP', 'MG', 'MC', 'IG', 'FG', 'RB'];

    const navigate = useNavigate();

    // Constantes de Reset
    const DATA_INICIO_DEFAULT = '2026-08-29';
    const amanha = new Date();
    amanha.setDate(amanha.getDate() + 1);
    const DATA_FIM_DEFAULT = amanha.toISOString().split('T')[0];

    // Estados
    const [dataInicio, setDataInicio] = useState(DATA_INICIO_DEFAULT);
    const [dataFim, setDataFim] = useState(DATA_FIM_DEFAULT);
    const [unidadeFiltro, setUnidadeFiltro] = useState("");
    const [data26, setData26] = useState([]);

    // Novos Estados para Filtros Avançados
    const [showFilters, setShowFilters] = useState(false);
    const [filtroTurma, setFiltroTurma] = useState("");
    const [filtroPlano, setFiltroPlano] = useState("");
    const [filtroTipoBolsa, setFiltroTipoBolsa] = useState("");

    // Alteração: Range com Mínimo e Máximo
    const [bolsaMin, setBolsaMin] = useState(0);
    const [bolsaMax, setBolsaMax] = useState(100);

    const convertSegmento = (seg) => {
        const segmentos = {
            '0-1': 'Mat 1', '0-2': 'Mat 2', '0-3': 'Pré 1', '0-4': 'Pré 2',
            '1-1': '1º Fund I', '1-2': '2º Fund I', '1-3': '3º Fund I', '1-4': '4º Fund I', '1-5': '5º Fund I',
            '1-6': '6º Fund II', '1-7': '7º Fund II', '1-8': '8º Fund II', '1-9': '9º Fund II',
            '2-1': '1ª Médio', '2-2': '2ª Médio', '2-3': '3ª Médio'
        };
        return segmentos[seg] || seg;
    };

    const fetchData = async () => {
        try {
            const response = await Lista_Meus_Alunos();
            const dadosUnicos = [...new Map(response.map(item => [item.matricula, item])).values()];
            setData26(dadosUnicos);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleLimparFiltros = () => {
        setDataInicio(DATA_INICIO_DEFAULT);
        setDataFim(DATA_FIM_DEFAULT);
        setUnidadeFiltro("");
        setFiltroTurma("");
        setFiltroPlano("");
        setFiltroTipoBolsa("");
        setBolsaMin(0);
        setBolsaMax(100);
    };

    // Lógica de Permissão de Unidade
    let userUnidades = [];
    if (meu_perfil === "GESTOR") {
        userUnidades = unidades_sigla.map((_, i) => i).filter(i => i > 0 && unidades_sigla[i]);
    } else if (meu_perfil.startsWith("DIRETOR") || meu_perfil.startsWith("SECRETARIA")) {
        const numerosString = meu_perfil.replace(/DIRETOR|SECRETARIA/, "").trim();
        userUnidades = numerosString.split("-").map(n => parseInt(n));
    }

    // Filtragem e Ordenação
    const filteredData = data26
        .filter(item => {
            const unidadePermitida = userUnidades.includes(parseInt(item.unidade));
            if (!unidadePermitida) return false;

            if (unidadeFiltro && parseInt(item.unidade) !== parseInt(unidadeFiltro)) return false;
            if (filtroTurma && item.turma !== filtroTurma) return false;
            if (filtroPlano && item.plano !== filtroPlano) return false;
            if (filtroTipoBolsa && item.tipo_bolsa !== filtroTipoBolsa) return false;

            // Lógica de Range Mínimo e Máximo
            const valorBolsa = parseFloat(item.bolsa || 0);
            if (valorBolsa < bolsaMin || valorBolsa > bolsaMax) return false;

            if (dataInicio && dataFim && item.data_ocorencia) {
                const dataCancelamento = item.data_ocorencia.split('T')[0];
                if (dataCancelamento < dataInicio || dataCancelamento > dataFim) return false;
            }
            return true;
        })
        .sort((a, b) => {
            if (a.unidade !== b.unidade) return a.unidade - b.unidade;
            if (a.turma !== b.turma) return a.turma.localeCompare(b.turma);
            return a.nome.localeCompare(b.nome);
        });

    // Cálculos do Footer
    const totalAlunos = filteredData.length;
    const bolsaMedia = totalAlunos > 0
        ? (filteredData.reduce((acc, curr) => acc + parseFloat(curr.bolsa || 0), 0) / totalAlunos).toFixed(2)
        : 0;
    const totalAlunosNovos = filteredData.filter(item => String(item.matricula).length === 9 && String(item.matricula).slice(2, 4) === '27').length;
    const totalAlunosRenovados = filteredData.filter(item => String(item.matricula).length === 9 && String(item.matricula).slice(2, 4) !== '27').length;


    // Opções únicas para os Selects do Offcanvas
    const turmasDisponiveis = [...new Set(data26.map(item => item.turma))].sort();
    const planosDisponiveis = [...new Set(data26.map(item => item.plano))].filter(Boolean).sort();
    const tiposBolsaDisponiveis = [...new Set(data26.map(item => item.tipo_bolsa))].filter(Boolean).sort();

    const handleExportCSV = () => { /* ... sua lógica de exportação atual ... */ };

    return (
        <div className="meus-alunos-container" style={{ paddingBottom: '70px' }}>
            <Navbar sticky="top" className="bg-body-tertiary px-3 shadow-sm">
                <Button variant="outline-primary" onClick={() => setShowFilters(true)} className="me-3">
                    ☰ Filtros Avançados
                </Button>
                <Nav.Link href="/" className="me-auto">Santa Mônica Rede de Ensino</Nav.Link>
                <Navbar.Brand className="me-auto fs-6 fw-bold text-success">MEUS ALUNOS</Navbar.Brand>

                <Form className="d-flex gap-2">
                    {meu_perfil === "GESTOR" && (
                        <Form.Select size="sm" value={unidadeFiltro} onChange={(e) => setUnidadeFiltro(e.target.value)}>
                            <option value="">Todas Unidades</option>
                            {userUnidades.map(cod => <option key={cod} value={cod}>{unidades[cod]}</option>)}
                        </Form.Select>
                    )}
                    <Button variant="danger" size="sm" onClick={() => navigate("/login")}>Sair</Button>
                </Form>
            </Navbar>

            {/* Offcanvas de Filtros */}
            <Offcanvas show={showFilters} onHide={() => setShowFilters(false)} placement="start">
                <Offcanvas.Header closeButton className="bg-light">
                    <Offcanvas.Title>Filtros de Pesquisa</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">Turma</Form.Label>
                            <Form.Select value={filtroTurma} onChange={(e) => setFiltroTurma(e.target.value)}>
                                <option value="">Todas</option>
                                {turmasDisponiveis.map(t => <option key={t} value={t}>{t}</option>)}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">Plano</Form.Label>
                            <Form.Select value={filtroPlano} onChange={(e) => setFiltroPlano(e.target.value)}>
                                <option value="">Todos</option>
                                {planosDisponiveis.map(p => <option key={p} value={p}>{p}</option>)}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">Tipo de Bolsa</Form.Label>
                            <Form.Select value={filtroTipoBolsa} onChange={(e) => setFiltroTipoBolsa(e.target.value)}>
                                <option value="">Todos</option>
                                {tiposBolsaDisponiveis.map(b => <option key={b} value={b}>{b}</option>)}
                            </Form.Select>
                        </Form.Group>

                        {/* Implementação do Range Mínimo e Máximo (Step 5) */}
                        <Form.Group className="mb-4">
                            <Form.Label className="fw-bold d-flex justify-content-between">
                                Faixa de Bolsa
                                <Badge bg="primary">{bolsaMin}% - {bolsaMax}%</Badge>
                            </Form.Label>
                            <div className="mt-2">
                                <small className="text-muted">Mínimo: {bolsaMin}%</small>
                                <Form.Range
                                    min="0" max="100" step="5"
                                    value={bolsaMin}
                                    onChange={(e) => setBolsaMin(parseInt(e.target.value))}
                                />
                                <small className="text-muted">Máximo: {bolsaMax}%</small>
                                <Form.Range
                                    min="0" max="100" step="5"
                                    value={bolsaMax}
                                    onChange={(e) => setBolsaMax(parseInt(e.target.value))}
                                />
                            </div>
                        </Form.Group>

                        <hr />

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">Data Início</Form.Label>
                            <Form.Control type="date" value={dataInicio} onChange={(e) => setDataInicio(e.target.value)} />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">Data Fim</Form.Label>
                            <Form.Control type="date" value={dataFim} onChange={(e) => setDataFim(e.target.value)} />
                        </Form.Group>

                        <Button variant="secondary" className="w-100 mb-2" onClick={handleLimparFiltros}>Limpar Tudo</Button>
                        <Button variant="primary" className="w-100" onClick={() => setShowFilters(false)}>Aplicar</Button>
                    </Form>
                </Offcanvas.Body>
            </Offcanvas>

            <div className="container-fluid mt-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">Relatório de Alunos</h5>
                    <Button variant="success" onClick={handleExportCSV}>Exportar CSV</Button>
                </div>

                <div className="table-responsive">
                    <Table striped bordered hover size="sm">
                        <thead className="table-dark">
                            <tr>
                                <th>UNIDADE</th>
                                <th>SIT.</th>
                                <th>MATRICULA</th>
                                <th>NOME</th>
                                <th>SÉRIE</th>
                                <th>TURMA</th>
                                <th>PLANO</th>
                                <th>TIPO DE BOLSA</th>
                                <th>BOLSA</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((item, index) => (
                                <tr key={index} style={item.sit !== '1' ? { color: 'red', fontSize: '90%' } : {}}>
                                    <td>{unidades[parseInt(item.unidade)]}</td>
                                    <td>{item.sit === '1' ? '🟢' : '🟡'}</td>
                                    <td style={{ color: String(item.matricula).length === 9 && String(item.matricula).slice(2, 4) === '27' ? 'blue' : 'black' }}>{item.matricula}</td>
                                    <td>{item.nome}</td>
                                    <td>{convertSegmento(item.seg)}</td>
                                    <td>{item.turma}</td>
                                    <td>{item.plano}</td>
                                    <td>{item.tipo_bolsa}</td>
                                    <td>{item.bolsa ? `${item.bolsa}%` : '0%'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </div>

            {/* Footer de Resumo */}
            <footer className="fixed-bottom bg-dark text-white p-2 shadow-lg">
                <div className="container-fluid d-flex justify-content-around align-items-center">
                    <span>Total de Alunos: <Badge bg="primary">{totalAlunos}</Badge></span>
                    <span>Alunos Novos: <Badge bg="info">{totalAlunosNovos}</Badge></span>
                    <span>Alunos Renovados: <Badge bg="warning">{totalAlunosRenovados}</Badge></span>
                    <span>Faixa de Bolsa: <Badge bg="secondary">{bolsaMin}% - {bolsaMax}%</Badge></span>
                    <span>Bolsa Média: <Badge bg="success">{bolsaMedia}%</Badge></span>
                </div>
            </footer>
        </div>
    );
}

export default Meus_Alunos;